import { __assign, __extends } from "tslib";
import { deepMix, isNil, map, some, every } from '@antv/util';
import * as EventParser from './event';
import ViewLayer from '../../base/view-layer';
import { getGeom } from '../../geoms/factory';
import { getPieLabel } from './component/label';
import SpiderLabel from './component/label/spider-label';
import { registerPlotType } from '../../base/global';
import { processEmpty, getOriginKey } from './utils';
import './theme';
var G2_GEOM_MAP = {
    pie: 'interval',
};
var PLOT_GEOM_MAP = {
    pie: 'column',
};
// @ts-ignore
var PieLayer = /** @class */ (function (_super) {
    __extends(PieLayer, _super);
    function PieLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'pie';
        return _this;
    }
    PieLayer.getDefaultOptions = function () {
        return deepMix({}, _super.getDefaultOptions.call(this), {
            width: 400,
            height: 400,
            title: {
                visible: false,
            },
            description: {
                visible: false,
            },
            forceFit: true,
            padding: 'auto',
            radius: 0.8,
            label: {
                visible: true,
                type: 'inner',
                autoRotate: false,
                adjustPosition: true,
                allowOverlap: false,
                line: {
                    visible: true,
                    smooth: true,
                },
            },
            legend: {
                visible: true,
                position: 'right-center',
            },
            tooltip: {
                visible: true,
                shared: false,
                showCrosshairs: false,
                showMarkers: false,
            },
            pieStyle: {
                stroke: 'white',
                lineWidth: 1,
            },
        });
    };
    PieLayer.prototype.afterRender = function () {
        _super.prototype.afterRender.call(this);
        var options = this.options;
        /** 蜘蛛布局label */
        if (options.label && options.label.visible) {
            // 清除，避免二次渲染
            if (this.labelComponent) {
                this.labelComponent.clear();
            }
            var labelConfig = options.label;
            if (labelConfig.type === 'spider') {
                this.labelComponent = new SpiderLabel(__assign({ view: this.view, fields: options.colorField ? [options.angleField, options.colorField] : [options.angleField] }, this.options.label));
                this.labelComponent.render();
            }
            else {
                var LabelCtor = getPieLabel(labelConfig.type);
                this.labelComponent = new LabelCtor(this, options.label);
                this.labelComponent.render();
            }
        }
    };
    PieLayer.prototype.getAngleScale = function () {
        var angleField = this.options.angleField;
        if (angleField) {
            return this.view.getScaleByField(angleField);
        }
    };
    PieLayer.prototype.geometryParser = function (dim, type) {
        if (dim === 'g2') {
            return G2_GEOM_MAP[type];
        }
        return PLOT_GEOM_MAP[type];
    };
    PieLayer.prototype.scale = function () {
        var props = this.options;
        _super.prototype.scale.call(this);
        var scales = {};
        scales[props.angleField] = {};
        scales[props.colorField] = { type: 'cat' };
        scales = deepMix({}, this.config.scales, scales);
        this.setConfig('scales', scales);
    };
    PieLayer.prototype.processData = function (data) {
        var _a, _b;
        var key = this.options.angleField;
        var originalKey = getOriginKey(key);
        var originalData = data.map(function (item) {
            var _a;
            var originalValue = typeof item[key] === 'string' ? Number.parseFloat(item[key]) : item[key];
            return __assign(__assign({}, item), (_a = {}, _a[key] = originalValue, _a[originalKey] = originalValue, _a));
        });
        var getValue = function (d) { return d[key]; };
        var notEqualZeroOrNil = function (v) { return v !== 0 && !isNil(v); };
        var allAngleValue = map(originalData, getValue);
        var allNil = every(allAngleValue, isNil);
        /** 数据全空处理，同时处理 meta */
        if (!some(allAngleValue, notEqualZeroOrNil)) {
            var meta = this.options.meta || {};
            // 数据全为 null
            if (allNil) {
                this.options.meta = deepMix({}, meta, (_a = {}, _a[key] = { formatter: function () { return 'null'; } }, _a));
                return processEmpty(originalData, key);
            }
            else {
                // 数据不全为 null，部分 0 部分 null（null值不展示）
                this.options.meta = deepMix({}, meta, (_b = {}, _b[key] = { formatter: function () { return '0'; } }, _b));
                return processEmpty(originalData, key, function (v) { return (v === 0 ? 1 : v); });
            }
        }
        return originalData;
    };
    PieLayer.prototype.axis = function () {
        return;
    };
    PieLayer.prototype.coord = function () {
        var props = this.options;
        var coordConfig = {
            type: 'theta',
            cfg: {
                radius: props.radius,
                // @ts-ignore 业务定制,不开放配置
                innerRadius: props.innerRadius || 0,
            },
        };
        this.setConfig('coordinate', coordConfig);
    };
    PieLayer.prototype.addGeometry = function () {
        var props = this.options;
        var pie = getGeom('interval', 'main', {
            plot: this,
            positionFields: [1, props.angleField],
        });
        pie.adjust = [{ type: 'stack' }];
        this.pie = pie;
        if (props.label) {
            this.label();
        }
        if (props.tooltip && (props.tooltip.fields || props.tooltip.formatter)) {
            this.geometryTooltip();
        }
        this.setConfig('geometry', pie);
    };
    PieLayer.prototype.geometryTooltip = function () {
        this.pie.tooltip = {};
        var tooltipOptions = this.options.tooltip;
        if (tooltipOptions.fields) {
            this.pie.tooltip.fields = tooltipOptions.fields;
        }
        if (tooltipOptions.formatter) {
            this.pie.tooltip.callback = tooltipOptions.formatter;
            if (!tooltipOptions.fields) {
                this.pie.tooltip.fields = [this.options.angleField, this.options.colorField];
            }
        }
    };
    PieLayer.prototype.animation = function () {
        _super.prototype.animation.call(this);
        var props = this.options;
        if (props.animation === false) {
            /** 关闭动画 */
            this.pie.animate = false;
        }
    };
    PieLayer.prototype.annotation = function () {
        return;
    };
    PieLayer.prototype.parseEvents = function (eventParser) {
        if (eventParser) {
            _super.prototype.parseEvents.call(this, eventParser);
        }
        else {
            _super.prototype.parseEvents.call(this, EventParser);
        }
    };
    PieLayer.prototype.label = function () {
        // 不使用 g2 内置label
        this.pie.label = false;
    };
    return PieLayer;
}(ViewLayer));
export default PieLayer;
registerPlotType('pie', PieLayer);
//# sourceMappingURL=layer.js.map